// @ts-nocheck

import useStreamConfig from '../../../../hooks/useStreamConfig';
import ImmersivePlayerContainer from '../../containers/ImmersivePlayerContainer';

const LiveVideoPlayer = ({ matchId, streamData, jwt, ...props }): Node => {
  const { url, config } = useStreamConfig({ streamData, matchId, jwt: jwt?.token });

  if (!config) {
    return null;
  }

  return (
    <ImmersivePlayerContainer
      fetchUrl={url}
      fetchConfig={config}
      streamData={streamData}
      matchId={matchId}
      {...props}
    />
  );
};

export default LiveVideoPlayer;
